import apiClient from "@/services/axios";
import ExcelJS from "exceljs";
import JsPDF from "jspdf";
function isNumber(value) {
  return !isNaN(Number(value));
}

const PvStyles = {
  all: {
    border: {
      top: { style: "medium", color: { argb: "4A8A9E" } },
      left: { style: "medium", color: { argb: "4A8A9E" } },
      bottom: { style: "medium", color: { argb: "4A8A9E" } },
      right: { style: "medium", color: { argb: "4A8A9E" } },
    },
    alignment: {
      horizontal: "center",
      vertical: "middle",
    },
    nameAlignment: {
      horizontal: "center",
      vertical: "right",
    },
  },
  ModuleHeaders: {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "ABE36E" },
  },
  secondHeader: {
    moy: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFC961" },
    },
    moduleMoy: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "8CC24A" },
    },
    moduleTotal: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFFF" },
    },
    subject: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFFF" },
    },
  },
};
const getCertificationNameByMoyenne = function (moyenne, certifs) {
  for (const cert of certifs)
    if (
      Number(moyenne) >= Number(cert.min) &&
      Number(moyenne) <= Number(cert.max)
    ) {
      return cert.name;
    }

  return "";
};

const getTrimesterNameArabic = (trimester) => {
  const trimesterNames = {
    1: "الثلاثي الأول",
    2: "الثلاثي الثاني",
    3: "الثلاثي الثالث",
  };
  return trimesterNames[trimester] || `الثلاثي ${trimester}`;
};

const getLevelNameArabic = (level) => {
  const levelNames = {
    "-2": "Préscolaire",
    "-1": "مستوى تحضيري",
    0: "مستوى تحضيري",
    1: "السنة الأولى",
    2: "السنة الثانية",
    3: "السنة الثالثة",
    4: "السنة الرابعة",
    5: "السنة الخامسة",
    6: "السنة السادسة",
    7: "السنة السابعة",
    8: "السنة الثامنة",
    9: "السنة التاسعة",
    10: "السنة الأولى ثانوي",
    11: "السنة الثانية ثانوي",
    12: "السنة الثالثة ثانوي",
    13: "السنة الرابعة ثانوي",
  };
  return levelNames[level] || `السنة ${level}`;
};

const formatSchoolYear = (schoolarYearName) => {
  if (!schoolarYearName) return "";
  const parts = schoolarYearName.split(" / ");
  if (parts.length === 2) {
    return `${parts[1]}-${parts[0]}`;
  }
  return schoolarYearName;
};
const getModules = async (level, type, trimester) => {
  let listModules = [];
  await apiClient
    .post("/bulletin/v2/module/filter", {
      query: {
        status: "active",
        level: level,
        trimester: trimester,
        type: type,
      },
    })
    .then((res) => {
      listModules = res.data;
    })
    .catch((e) => {
      console.log(e);
    });
  return listModules;
};

const getSubModule = async (id) => {
  try {
    const { data } = await apiClient.get(`/bulletin/v2/sub-module/${id}`);
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
};
const ARABIC_CHAR_REGEX = /[\u0600-\u06FF]/;
const toNumericMoyenne = (value) => {
  if (value === null || value === undefined) return null;
  if (String(value).trim() === "--") return null;
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : null;
};
const getStudentSortableName = (student) =>
  String(student?.fullName || student?.fullNameFr || "").trim();
const sortPvStudents = (students, sortBy, sortOrder) => {
  if (!Array.isArray(students)) return [];
  if (!["moyenne", "name"].includes(sortBy)) return students;

  const direction = sortOrder === "desc" ? -1 : 1;
  const sorted = [...students];

  if (sortBy === "moyenne") {
    sorted.sort((a, b) => {
      const aMoyenne = toNumericMoyenne(a?.moyenne);
      const bMoyenne = toNumericMoyenne(b?.moyenne);
      if (aMoyenne === null && bMoyenne === null) return 0;
      if (aMoyenne === null) return 1;
      if (bMoyenne === null) return -1;
      return (aMoyenne - bMoyenne) * direction;
    });
    return sorted;
  }

  sorted.sort((a, b) => {
    const aName = getStudentSortableName(a);
    const bName = getStudentSortableName(b);
    const aArabic = ARABIC_CHAR_REGEX.test(aName);
    const bArabic = ARABIC_CHAR_REGEX.test(bName);

    if (aArabic !== bArabic) {
      if (sortOrder === "asc") return aArabic ? -1 : 1;
      return aArabic ? 1 : -1;
    }

    return (
      aName.localeCompare(bName, ["ar", "fr", "en"], {
        sensitivity: "base",
        ignorePunctuation: true,
        numeric: true,
      }) * direction
    );
  });
  return sorted;
};
const applyPvSorting = (pvResponse, sortBy, sortOrder) => {
  if (!pvResponse || !Array.isArray(pvResponse.students)) return pvResponse;
  const students = pvResponse.students;
  const numericValues = (field) =>
    students.map((s) => toNumericMoyenne(s?.[field])).filter((v) => v !== null);

  const personalizedValues = numericValues("personalizedMoyenne");
  const normalValues = numericValues("moyenne");

  return {
    ...pvResponse,
    minMoyenne:
      normalValues.length > 0
        ? String(Math.min(...normalValues).toFixed(2))
        : pvResponse.minMoyenne,
    maxMoyenne:
      normalValues.length > 0
        ? String(Math.max(...normalValues).toFixed(2))
        : pvResponse.maxMoyenne,
    personalizedMoyenneMin:
      personalizedValues.length > 0
        ? String(Math.min(...personalizedValues).toFixed(2))
        : null,
    personalizedMoyenneMax:
      personalizedValues.length > 0
        ? String(Math.max(...personalizedValues).toFixed(2))
        : null,
    students: sortPvStudents(students, sortBy, sortOrder),
  };
};
const printPVBulletin = async (config) => {
  const {
    selectedLevel,
    selectedTrimester,
    bulletinType,
    certifs,
    selectedClasse,
    selectedClassName,
    sortBy,
    sortOrder,
    usePersonalizedAverage,
    schoolarYearName,
  } = config;

  const doc = new JsPDF({
    orientation: "l",
    unit: "mm",
    format: "a3",
  });
  let bulletinData;

  await apiClient
    .get(
      "/bulletin/v2/pv/classroom/" +
      bulletinType +
      "/" +
      selectedClasse +
      "/" +
      selectedTrimester
    )
    .then(({ data }) => {
      bulletinData = applyPvSorting(data, sortBy, sortOrder);
    });

  const cellToDelete = {};
  const head = [];
  const modulesHead = [];

  const defaultMax = [cellToDelete];
  const defaultMin = [cellToDelete];
  defaultMax.unshift({ content: "اعلى عدد بالقسم", colSpan: 2 }, cellToDelete);
  defaultMin.unshift({ content: "ادنى عدد بالقسم", colSpan: 2 }, cellToDelete);
  let listModules = await getModules(
    selectedLevel,
    bulletinType,
    selectedTrimester
  );
  const moduleMetaById = new Map();
  listModules.forEach((m) => {
    if (m && m._id) {
      moduleMetaById.set(m._id, m);
    }
  });
  const subModulesRow = [cellToDelete];
  let hasAnySubmodules = false;

  for (const m of listModules) {
    if (!m || !m.subjects || !Array.isArray(m.subjects)) continue;

    const subjectsInfo = m.subjectsInfo || {};
    const subModuleIds = new Set();
    (m.subjects || []).forEach((s) => {
      if (!s || !s._id) return;
      const sousModuleId = subjectsInfo[s._id]?.sousModule;
      if (sousModuleId) {
        subModuleIds.add(sousModuleId);
      }
    });
    const subModulesData = {};
    const subModulePromises = Array.from(subModuleIds).map(async (sousModuleId) => {
      const subModuleData = await getSubModule(sousModuleId);
      subModulesData[sousModuleId] = subModuleData?.name || "";
    });
    await Promise.all(subModulePromises);

    const subModuleGroups = {};

    (m.subjects || []).forEach((s) => {
      if (!s || !s._id) return;
      const sousModuleId = subjectsInfo[s._id]?.sousModule;
      if (sousModuleId) {
        if (!subModuleGroups[sousModuleId]) {
          subModuleGroups[sousModuleId] = [];
        }
        subModuleGroups[sousModuleId].push(s);
      }
    });

    const segments = [];
    const processedSubModules = new Set();

    (m.subjects || []).forEach((s) => {
      if (!s || !s._id) return;
      const sousModuleId = subjectsInfo[s._id]?.sousModule;
      if (sousModuleId) {

        if (!processedSubModules.has(sousModuleId)) {
          processedSubModules.add(sousModuleId);
          segments.push({
            type: "submodule",
            sousModuleId,
            subjects: subModuleGroups[sousModuleId],
            name: subModulesData[sousModuleId],
          });
        }
      } else {
        segments.push({ type: "single", subject: s });
      }
    });

    const moduleHasSubmodules = segments.some(seg => seg.type === "submodule");
    if (moduleHasSubmodules) hasAnySubmodules = true;

    if (moduleHasSubmodules) {

      for (let i = segments.length - 1; i >= 0; i--) {
        const seg = segments[i];

        if (seg.type === "single") {

          subModulesRow.unshift("");
        } else if (seg.type === "submodule") {

          const colSpan = seg.subjects.length + 2; // subjects + المجموع + المعدل
          subModulesRow.unshift({
            content: seg.name || "",
            colSpan: colSpan,
          });

          for (let j = 1; j < colSpan; j++) {
            subModulesRow.unshift(cellToDelete);
          }
        }
      }

      subModulesRow.unshift({ content: "", colSpan: 2 });
    } else {
      subModulesRow.unshift({
        content: "",
        colSpan: m.subjects.length + 2,
      });

      for (let i = 0; i < m.subjects.length + 1; i++) {
        subModulesRow.unshift(cellToDelete);
      }
    }
  }

  const emptySubModuleRow = [cellToDelete];
  listModules.forEach((m) => {

    const subjectsInfo = m.subjectsInfo || {};

    //  group all subjects by their sub-module ID
    const subModuleGroups = {};
    (m.subjects || []).forEach((s) => {
      if (!s || !s._id) return;
      const sousModuleId = subjectsInfo[s._id]?.sousModule;
      if (sousModuleId) {
        if (!subModuleGroups[sousModuleId]) {
          subModuleGroups[sousModuleId] = [];
        }
        subModuleGroups[sousModuleId].push(s);
      }
    });

    const segments = [];
    const processedSubModules = new Set();

    (m.subjects || []).forEach((s) => {
      if (!s || !s._id) return;
      const sousModuleId = subjectsInfo[s._id]?.sousModule;
      if (sousModuleId) {

        if (!processedSubModules.has(sousModuleId)) {
          processedSubModules.add(sousModuleId);
          segments.push({
            type: "submodule",
            sousModuleId,
            subjects: subModuleGroups[sousModuleId],
          });
        }
      } else {
        segments.push({ type: "single", subject: s });
      }
    });

      let moduleColumnCount = 0;

    for (let i = segments.length - 1; i >= 0; i--) {
      const seg = segments[i];
      if (seg.type === "single") {
        head.unshift(seg.subject.name);
        defaultMax.unshift({ content: "--" });
        defaultMin.unshift({ content: "--" });
        emptySubModuleRow.unshift("");
        moduleColumnCount += 1;
      } else if (seg.type === "submodule") {
        // Add subject names (process subjects in reverse order too)
        for (let j = seg.subjects.length - 1; j >= 0; j--) {
          const s = seg.subjects[j];
          head.unshift(s.name);
          defaultMax.unshift({ content: "--" });
          defaultMin.unshift({ content: "--" });
          emptySubModuleRow.unshift("");
          moduleColumnCount += 1;
        }
        head.unshift("المجموع");
        defaultMax.unshift({ content: "--" });
        defaultMin.unshift({ content: "--" });
        emptySubModuleRow.unshift("");
        moduleColumnCount += 1;

        head.unshift("معدل المادة");
        defaultMax.unshift({ content: "--" });
        defaultMin.unshift({ content: "--" });
        emptySubModuleRow.unshift("");
        moduleColumnCount += 1;
      }
    }

    // Add module-level totals
    head.unshift("المجموع");
    head.unshift("معدل المجال");
    defaultMax.unshift("", "");
    defaultMin.unshift("", "");
    emptySubModuleRow.unshift("", "");
    moduleColumnCount += 2;

    modulesHead.unshift({
      content: m.name,
      colSpan: moduleColumnCount,
    });
    for (let i = 0; i < moduleColumnCount - 1; i++)
      modulesHead.unshift(cellToDelete);
  });
  head.unshift("مجموع المجالات");
  head.unshift("المعدل");
  head.unshift("الرتبة");
  head.unshift("الشهادة");
  defaultMax.unshift("", "--", "", "");
  defaultMin.unshift("", "--", "", "");
  emptySubModuleRow.unshift("", "", "", "");
  if (hasAnySubmodules) {
    subModulesRow.unshift({ content: "", colSpan: 4 });
  }

  modulesHead.unshift({ content: "النتيجة", colSpan: 4 });
  for (let i = 0; i < 3; i++) modulesHead.unshift(cellToDelete);

  const sMax = [cellToDelete];
  const sMin = [cellToDelete];
  sMax.unshift({ content: "اعلى عدد بالقسم", colSpan: 2 }, cellToDelete);
  sMin.unshift({ content: "ادنى عدد بالقسم", colSpan: 2 }, cellToDelete);

  const data = [];
  let studentID = 1;
  bulletinData.students.forEach((student) => {
    const studentData = [];
    studentData.unshift(studentID++);
    studentData.unshift(student.fullName);
    let mSum = 0;
    student.modules.forEach((m) => {
      try {
        const moduleMeta = moduleMetaById.get(m._id) || {};
        const subjectsInfo = moduleMeta.subjectsInfo || {};

        const subModuleGroups = {};
        (m.subjects || []).forEach((s) => {
          if (!s || !s._id) return;

          const sousModuleId = s.submoduleID || subjectsInfo[s._id]?.sousModule;
          if (sousModuleId) {
            if (!subModuleGroups[sousModuleId]) {
              subModuleGroups[sousModuleId] = [];
            }
            subModuleGroups[sousModuleId].push(s);
          }
        });

        const segments = [];
        const processedSubModules = new Set();

        (m.subjects || []).forEach((s) => {
          if (!s || !s._id) return;

          const sousModuleId = s.submoduleID || subjectsInfo[s._id]?.sousModule;
          if (sousModuleId) {

            if (!processedSubModules.has(sousModuleId)) {
              processedSubModules.add(sousModuleId);
              segments.push({
                type: "submodule",
                sousModuleId,
                subjects: subModuleGroups[sousModuleId],
              });
            }

          } else {
            segments.push({ type: "single", subject: s });
          }
        });

        // We'll build all module cells then unshift them at once
        const moduleCells = [];
        const moduleMaxCells = [];
        const moduleMinCells = [];

        let moduleWeightedSum = 0; // for mSum
        let moduleSubjectsSum = 0; // raw sum of all subject marks (existing "المجموع" column)

        for (let i = segments.length - 1; i >= 0; i--) {
          const seg = segments[i];
          if (seg.type === "single") {
            const s = seg.subject;
            const mark = isNumber(s.mark) ? Number(s.mark).toFixed(2) : "--";
            moduleCells.unshift(mark);
            if (isNumber(s.mark)) {
              moduleSubjectsSum += Number(s.mark);
            }

            if (studentID == 2) {
              moduleMaxCells.unshift({
                content: isNumber(s.max) ? Number(s.max).toFixed(2) : "--",
              });
              moduleMinCells.unshift({
                content: isNumber(s.min) ? Number(s.min).toFixed(2) : "--",
              });
            }
          } else if (seg.type === "submodule") {
            let subSum = 0;

            // Process subjects in reverse order to match head building
            for (let j = seg.subjects.length - 1; j >= 0; j--) {
              const s = seg.subjects[j];
              const mark = isNumber(s.mark) ? Number(s.mark).toFixed(2) : "--";
              moduleCells.unshift(mark);

              if (isNumber(s.mark)) {
                const num = Number(s.mark);
                subSum += num;
                moduleSubjectsSum += num;
              }

              if (studentID == 2) {
                moduleMaxCells.unshift({
                  content: isNumber(s.max) ? Number(s.max).toFixed(2) : "--",
                });
                moduleMinCells.unshift({
                  content: isNumber(s.min) ? Number(s.min).toFixed(2) : "--",
                });
              }
            }

            // Get sub-module moyenne from API response (m.submodules array)
            const subModuleData = m.submodules?.find(
              (sm) => sm._id === seg.sousModuleId
            );

            const subAvg = subModuleData?.moyenne
              ? (isNumber(subModuleData.moyenne)
                ? Number(subModuleData.moyenne).toFixed(2)
                : subModuleData.moyenne)
              : "--";
            // Calculate sum (المجموع) from subject marks
            const subTotal = subSum > 0 ? subSum.toFixed(2) : "--";

            // Add in same order as head: unshift("المعدل"), then unshift("المجموع")
            moduleCells.unshift(subTotal);  // المجموع (calculated sum, added second, so appears after المعدل)
            moduleCells.unshift(subAvg);   // المعدل (from API, added first, so appears after subjects)

            if (studentID == 2) {
              // We don't have class max/min per sub-module; keep as "--"
              moduleMaxCells.unshift({ content: "" }); // المعدل
              moduleMaxCells.unshift({ content: "" }); // المجموع
              moduleMinCells.unshift({ content: "" }); // المعدل
              moduleMinCells.unshift({ content: "" }); // المجموع
            }
          }
        }
        const moduleTotal = moduleSubjectsSum.toFixed(2);
        moduleCells.unshift(moduleTotal);    // المجموع
        moduleCells.unshift(m.moyenne);      // معدل المجال

        if (studentID == 2) {
          // For max/min rows: keep same behaviour as before
          moduleMaxCells.unshift("");
          moduleMaxCells.unshift(m.maxMoyenne || "--");
          moduleMinCells.unshift("");
          moduleMinCells.unshift(m.minMoyenne || "--");
        }

        studentData.unshift(...moduleCells);
        if (studentID == 2) {
          sMax.unshift(...moduleMaxCells);
          sMin.unshift(...moduleMinCells);
        }


        if (m.moyenne != "--") moduleWeightedSum += Number(m.moyenne * m.coef);
        mSum += moduleWeightedSum;
      } catch (error) {
        console.log(student, m, error);
      }
    });
    studentData.unshift(mSum.toFixed(2));
    const rank =
      usePersonalizedAverage &&
        bulletinType === "MS" &&
        student.personalizedRank
        ? student.personalizedRank
        : student.rank;
    const moyenne =
      usePersonalizedAverage && bulletinType === "MS"
        ? student.personalizedMoyenne
        : student.moyenne;

    studentData.unshift(moyenne);
    studentData.unshift(rank);
    studentData.unshift(getCertificationNameByMoyenne(moyenne, certifs));

    data.push(studentData);
  });

  const max =
    usePersonalizedAverage &&
      bulletinType === "MS" &&
      bulletinData.personalizedMoyenneMax
      ? bulletinData.personalizedMoyenneMax
      : bulletinData.maxMoyenne;

  const min =
    usePersonalizedAverage &&
      bulletinType === "MS" &&
      bulletinData.personalizedMoyenneMin
      ? bulletinData.personalizedMoyenneMin
      : bulletinData.minMoyenne;

  sMax.unshift("", "", max, "");
  sMin.unshift("", "", min, "");

  if (bulletinData.students.length === 0) {
    data.push(defaultMax);
    data.push(defaultMin);
  } else {
    data.push(sMax);
    data.push(sMin);
  }
  const array = [
    [...modulesHead, { content: "", colSpan: 2 }, cellToDelete],
    ...(hasAnySubmodules ? [[...subModulesRow, { content: "", colSpan: 2 }, cellToDelete]] : []),
    [
      { content: "الشهادة" },
      ...Array(head.length - 1).fill(""),
      { content: bulletinData.classroomName, colSpan: 2 },
      cellToDelete,
    ],
    ...data,
  ];

  // fix table
  for (let row = 0; row < array.length; row++) {
    array[row] = array[row].filter((cell) => cell !== cellToDelete);
  }

  const className = selectedClassName;
  doc.setFont("Amiri", "Bold");
  doc.setFontSize(14);

  const trimesterName = getTrimesterNameArabic(selectedTrimester);
  const levelName = getLevelNameArabic(selectedLevel);
  const schoolYear = formatSchoolYear(schoolarYearName);
  const LTR = "\u2066";
  const RTL = "\u2067";
  const PDI = "\u2069";

  const fixedClassName = `${LTR}${className}${PDI}`;
  const fixedSchoolYear = `${LTR}${schoolYear}${PDI}`;

  const headerText =
    `${fixedSchoolYear} | ` +
    `${fixedClassName} | ` +
    `${RTL}${levelName}${PDI} | ` +
    `${RTL}نتائج ${trimesterName}${PDI}`;
  const pdfWidth = doc.internal.pageSize.getWidth();
  const headerX = pdfWidth / 2;
  const headerY = 8;

  doc.text(headerText, headerX, headerY, { align: "center" });

  const tableMargin = 6;
  const tableWidth = pdfWidth - 2 * tableMargin;

  doc.autoTable({
    startY: 15,
    margin: { left: tableMargin, right: tableMargin },
    tableWidth: tableWidth,
    body: array,
    theme: "striped",
    styles: {},
    bodyStyles: {
      lineWidth: 0.2,
      lineColor: [73, 138, 159],
      halign: "center",
      valign: "middle",
      fontSize: 8,
      cellPadding: 1.2,
      textColor: [0, 0, 0],
      minCellHeight: 8,
    },
    rowPageBreak: "avoid",
    columnStyles: {
      0: {
        columnWidth: 20,
      },
    },

    didDrawCell: function (data) {
      const length = data.row.raw.length;
      const subjectRowIndex = hasAnySubmodules ? 2 : 1;
      if (
        data.row.index === subjectRowIndex &&
        data.column.index < length - 1 &&
        data.column.index !== 0
      ) {
        const textWidth = doc.getTextWidth(head[data.column.index]);
        const x = data.cell.x + data.cell.width / 2;
        const cellCenterY = data.cell.y + data.cell.height / 2;
        const y = cellCenterY + textWidth / 2;
        doc.text(head[data.column.index], x, y, { angle: 90 });
      }
    },

    didParseCell: function (data) {
      const length = data.row.raw.length;
      const subjectRowIndex = hasAnySubmodules ? 2 : 1;

      data.cell.styles.textColor = [0, 0, 0];
      data.cell.styles.halign = "center";
      data.cell.styles.valign = "middle";

      if (data.column.index === length - 1) data.cell.styles.fontSize = 11;

      if (data.row.index == subjectRowIndex) {
        doc.setFont("Amiri", "normal");
        doc.setFontSize(12);
        let maxHeaderWidth = 0;
        for (let i = 0; i < head.length; i++) {
          const w = doc.getTextWidth(head[i] || "");
          if (w > maxHeaderWidth) maxHeaderWidth = w;
        }
        const cellStr = Array.isArray(data.cell.text) ? data.cell.text.join(" ") : String(data.cell.text ?? "");
        if (cellStr) {
          const wCell = doc.getTextWidth(cellStr);
          if (wCell > maxHeaderWidth) maxHeaderWidth = wCell;
        }
        data.cell.styles.minCellHeight = Math.max(36, maxHeaderWidth + 14);
        data.cell.styles.minCellWidth = 5;
        data.cell.styles.halign = "center";
        data.cell.styles.valign = "center";

        if (data.column.index !== length - 1) data.cell.styles.fontSize = 12;
        else data.cell.styles.fontSize = 12;

        if (
          [
            "معدل المجال",
            "المعدل",
            "المجموع",
            "مجموع المجالات",
            "الرتبة",
          ].includes(head[data.column.index])
        ) {
          data.cell.styles.fontStyle = "Bold";
          data.cell.styles.fontSize = 9.5;
        } else data.cell.styles.fontStyle = "normal";
        if ("معدل المجال" == head[data.column.index])
          data.cell.styles.fillColor = "#8bc34a";
        if ("معدل المادة" == head[data.column.index])
          data.cell.styles.fillColor = "#ffca62";
        else if ("المعدل" == head[data.column.index])
          data.cell.styles.fillColor = "#ffca62";
      } else {
        if (data.column.index == length - 1) data.cell.styles.fontSize = 8;
        if (
          data.column.index === length - 2 &&
          data.row.index > subjectRowIndex &&
          data.row.index < array.length - 2
        ) {
          data.cell.styles.fontSize = 10.5;
          data.cell.styles.fontStyle = "Bold";
        }
      }

      if (data.row.index == 0) {
        data.cell.styles.fontSize = 11;
        data.cell.styles.fillColor = "#ace36d";
      }
      if (data.row.index == 1 && hasAnySubmodules) {
        data.cell.styles.minCellHeight = 3;
        data.cell.styles.fontSize = 10;
      }
      //classname always Amiri
      if (data.row.index == subjectRowIndex && data.column.index == length - 1)
        data.cell.styles.font = "Amiri";
      else if (/[a-zA-Z]/.test(data.cell.text[0]))
        data.cell.styles.font = "helvetica";
      else if (
        data.row.index !== subjectRowIndex &&
        (!isNaN(Number(data.cell.text[0])) || data.cell.text[0] == "--")
      ) {
        data.cell.styles.font = "helvetica";
        data.cell.styles.fontStyle = "Bold";
      } else data.cell.styles.font = "Amiri";

      //last -1 row
      if (data.row.index == array.length - 2) {
        const cellStr = Array.isArray(data.cell.text) ? data.cell.text.join(" ") : String(data.cell.text ?? "");
        if (cellStr === "اعلى عدد بالقسم") data.cell.styles.fontSize = 10.5;
        if (data.column.index !== length - 1)
          data.cell.styles.textColor = "#8bc34a";
        else data.cell.styles.fillColor = "#8bc34a";
        if (data.cell.styles.font == "Amiri")
          data.cell.styles.fontStyle = "Bold";
      }
      //last row
      if (data.row.index == array.length - 1) {
        const cellStr = Array.isArray(data.cell.text) ? data.cell.text.join(" ") : String(data.cell.text ?? "");
        if (cellStr === "ادنى عدد بالقسم") data.cell.styles.fontSize = 10.5;
        if (data.column.index !== length - 1)
          data.cell.styles.textColor = "#f44336";
        else data.cell.styles.fillColor = "#ffaea8";
        if (data.cell.styles.font == "Amiri")
          data.cell.styles.fontStyle = "Bold";
      }
    },
  });

  let typeLabel = "";
  if (config.bulletinType === "MP") typeLabel = "Pédagogique";
  if (config.bulletinType === "MT") typeLabel = "Pilote";
  if (config.bulletinType === "MS") typeLabel = "Spécifique";

  doc.save(`PV ${typeLabel} ${className}.pdf`);
};

const PV_EXCEL_LEVEL_NAMES = {
  "-2": "Préscolaire",
  "-1": "Préscolaire",
  0: " مستوى تحضيري",
  1: "مستوى أولى",
  2: "مستوى ثانية",
  3: "مستوى ثالثة",
  4: "مستوى رابعة",
  5: "مستوى خامسة",
  6: "مستوى سادسة",
  7: "مستوى سابعة",
  8: "مستوى ثامنة",
  9: "مستوى تاسعة",
  10: " مستوى أولى ثانوي ",
  11: " مستوى ثانية ثانوي",
  12: " مستوى ثالثة ثانوي",
  13: " مستوى رابعة ثاتوي",
  other: "أخرى",
};

const getPvExcelLevelSheetName = (level) =>
  PV_EXCEL_LEVEL_NAMES[String(level)] ?? PV_EXCEL_LEVEL_NAMES.other;

const printPVBulletinExcel = async (config) => {
  console.clear();
  const {
    selectedLevel,
    selectedTrimester,
    bulletinType,
    certifs,
    selectedClasse,
    selectedClassName,
    sortBy,
    sortOrder,
    usePersonalizedAverage,
    document,
    onLevel,
  } = config;
  const btTypeName =
    bulletinType == "MS"
      ? "Specifique"
      : bulletinType == "MT"
        ? "Pilote"
        : "Pedagogique";
  const workbook = new ExcelJS.Workbook();
  let exportTargets = [];

  if (onLevel) {
    try {
      const { data } = await apiClient.get(
        "/bulletin/v2/pv/level_all/" + bulletinType + "/" + selectedTrimester
      );
      const levelData = Array.isArray(data)
        ? data.map((item) => applyPvSorting(item, sortBy, sortOrder))
        : [];
      exportTargets = levelData
        .filter((item) => item?.students?.length > 0)
        .sort((a, b) => Number(a.level) - Number(b.level))
        .map((item) => ({
          bulletinData: item,
          level: Number(item.level),
        }));
    } catch (e) {
      console.error("Error fetching level data:", e);
      return;
    }
  } else {
    try {
      const { data } = await apiClient.get(
        "/bulletin/v2/pv/classroom/" +
          bulletinType +
          "/" +
          selectedClasse +
          "/" +
          selectedTrimester
      );
      exportTargets = [
        {
          bulletinData: applyPvSorting(data, sortBy, sortOrder),
          level: Number(selectedLevel),
        },
      ];
    } catch (e) {
      console.error("Error fetching classroom PV data:", e);
      return;
    }
  }

  for (const { bulletinData, level } of exportTargets) {
    if (!bulletinData?.students?.length) continue;

    const levelName = onLevel ? getPvExcelLevelSheetName(level) : selectedClassName;
    const worksheet = workbook.addWorksheet(levelName);

    const fullModules = await getModules(
      onLevel ? level : selectedLevel,
      bulletinType,
      selectedTrimester
    );

    const moduleMetaById = new Map();
    fullModules.forEach((m) => {
      if (m && m._id) {
        moduleMetaById.set(m._id, m);
      }
    });

    const modulesWithSegments = [];
    let hasAnySubmodules = false;

    for (const m of bulletinData.students[0].modules) {
      const fullModule = moduleMetaById.get(m._id) || {};
      const subjectsInfo = fullModule.subjectsInfo || {};

      const subModuleIds = new Set();
      (m.subjects || []).forEach((s) => {
        if (!s || !s._id) return;
        const sousModuleId = s.submoduleID || subjectsInfo[s._id]?.sousModule;
        if (sousModuleId) {
          subModuleIds.add(sousModuleId);
        }
      });


      const subModulesData = {};
      const subModulePromises = Array.from(subModuleIds).map(async (sousModuleId) => {
        const subModuleData = await getSubModule(sousModuleId);
        subModulesData[sousModuleId] = subModuleData?.name || "";
      });
      await Promise.all(subModulePromises);

      // Build segments: group subjects by sub-module while maintaining order
      const subModuleGroups = {};
      (m.subjects || []).forEach((s) => {
        if (!s || !s._id) return;
        const sousModuleId = s.submoduleID || subjectsInfo[s._id]?.sousModule;
        if (sousModuleId) {
          if (!subModuleGroups[sousModuleId]) {
            subModuleGroups[sousModuleId] = [];
          }
          subModuleGroups[sousModuleId].push(s);
        }
      });

      const segments = [];
      const processedSubModules = new Set();

      (m.subjects || []).forEach((s) => {
        if (!s || !s._id) return;
        const sousModuleId = s.submoduleID || subjectsInfo[s._id]?.sousModule;
        if (sousModuleId) {
          if (!processedSubModules.has(sousModuleId)) {
            processedSubModules.add(sousModuleId);
            segments.push({
              type: "submodule",
              sousModuleId,
              subjects: subModuleGroups[sousModuleId],
              name: subModulesData[sousModuleId],
            });
          }
        } else {
          segments.push({ type: "single", subject: s });
        }
      });

      const moduleHasSubmodules = segments.some(seg => seg.type === "submodule");
      if (moduleHasSubmodules) hasAnySubmodules = true;

      modulesWithSegments.push({
        name: m.name,
        _id: m._id,
        segments: segments.reverse(),
        fullModule,
      });
    }

    modulesWithSegments.reverse();

    worksheet.addRow(["", ...modulesWithSegments.map((m) => m.name), ""]);
    const makeHeaderCell = (cell, value = null) => {
      cell.alignment = PvStyles.all.alignment;
      cell.fill = PvStyles.ModuleHeaders;
      cell.border = PvStyles.all.border;
      if (value) cell.value = value;
    };

    /**************************************************
     * Headers Row (module names and class/level name)**
     * *************************************************
     */
    // printing النتيجة
    worksheet.mergeCells(1, 1, 1, 4);
    makeHeaderCell(worksheet.getCell(1, 1), "النتيجة");

    let currentColumn = 5;
    modulesWithSegments.forEach((module) => {
      let moduleColumnCount = 0;
      module.segments.forEach((seg) => {
        if (seg.type === "single") {
          moduleColumnCount += 1;
        } else if (seg.type === "submodule") {
          moduleColumnCount += seg.subjects.length + 2; // subjects + المجموع + المعدل
        }
      });
      moduleColumnCount += 2; // معدل المجال + المجموع

      worksheet.mergeCells(
        1,
        currentColumn,
        1,
        currentColumn + moduleColumnCount - 1
      );
      makeHeaderCell(worksheet.getCell(1, currentColumn), module.name);
      currentColumn += moduleColumnCount;
    });
    worksheet.mergeCells(1, currentColumn, 1, currentColumn + 1);
    makeHeaderCell(worksheet.getCell(1, currentColumn), " ");

    /**************************************************
     * Second Row (sous-modules row)*********************
     * *************************************************/
    const subModulesRow = ["", "", "", ""];
    const subModuleMerges = []; // Track cells to merge

    let col = 5;
    for (const module of modulesWithSegments) {
      const moduleHasSubmodules = module.segments.some(seg => seg.type === "submodule");

      // Add empty cells for module-level totals first (معدل المجال + المجموع) - matching new header order
      subModulesRow.push("", "");
      col += 2;

      if (moduleHasSubmodules) {
        // Process segments in reverse order (matching header building)
        for (let i = module.segments.length - 1; i >= 0; i--) {
          const seg = module.segments[i];
          if (seg.type === "single") {
            subModulesRow.push("");
            col++;
          } else if (seg.type === "submodule") {
            // Sub-module group: span over معدل المادة + المجموع + subjects (matching new header order)
            const colSpan = 2 + seg.subjects.length; // معدل المادة + المجموع + subjects
            subModuleMerges.push({ startCol: col, span: colSpan, name: seg.name || "" });
            // Add empty cells for the span (will be merged)
            for (let j = 0; j < colSpan; j++) {
              subModulesRow.push("");
              col++;
            }
          }
        }
      } else {
        // No sub-modules: just empty cells for segments
        module.segments.forEach((seg) => {
          if (seg.type === "single") {
            subModulesRow.push("");
            col++;
          }
        });
      }
    }

    // Determine header row count based on whether submodules exist
    const headerRowCount = hasAnySubmodules ? 3 : 2;

    // Only add the submodule row if there are any submodules
    if (hasAnySubmodules) {
      worksheet.addRow(subModulesRow);

      // Style and merge cells
      for (let c = 1; c <= currentColumn + 1; c++) {
        const cell = worksheet.getCell(2, c);
        cell.border = PvStyles.all.border;
        cell.alignment = PvStyles.all.alignment;

        if (c >= 5 && c < currentColumn) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFFFF" },
          };
          cell.font = { ...cell.font, bold: true };
        }
      }


      try {
        worksheet.mergeCells(2, 1, 2, 4);
      } catch (e) {
        console.log("Merge conflict for النتيجة section:", e);
      }

      // Track merged ranges to avoid conflicts
      const mergedRanges = [{ start: 1, end: 4 }];

      // Apply merges for grouped submodules
      for (const merge of subModuleMerges) {
        const mergeStart = merge.startCol;
        const mergeEnd = merge.startCol + merge.span - 1;

        // Check if this merge overlaps with any existing merge
        const overlaps = mergedRanges.some(range =>
          (mergeStart >= range.start && mergeStart <= range.end) ||
          (mergeEnd >= range.start && mergeEnd <= range.end) ||
          (range.start >= mergeStart && range.end <= mergeEnd)
        );

        if (!overlaps && merge.span > 0 && merge.startCol > 0) {
          try {
            worksheet.mergeCells(2, merge.startCol, 2, merge.startCol + merge.span - 1);
            // Set the merged cell value
            worksheet.getCell(2, merge.startCol).value = merge.name;
            mergedRanges.push({ start: mergeStart, end: mergeEnd });
          } catch (e) {
            console.log("Merge conflict for submodule:", merge, e);
          }
        }
      }

      // Merge معدل المجال & المجموع for each module (only if not already merged)
      // Now module-level totals are at the beginning of each module
      col = 5;
      for (const module of modulesWithSegments) {
        const moyCol = col; // معدل المجال is first
        const sumCol = col + 1; // المجموع is second

        // Check if these columns are already part of a merge
        const isMerged = mergedRanges.some(range =>
          (moyCol >= range.start && moyCol <= range.end) ||
          (sumCol >= range.start && sumCol <= range.end)
        );

        if (!isMerged) {
          try {
            worksheet.mergeCells(2, moyCol, 2, sumCol);
            mergedRanges.push({ start: moyCol, end: sumCol });
          } catch (e) {
            console.log("Merge conflict for معدل & مجموع:", e);
          }
        }

        // Calculate module column count to advance col
        let moduleColumnCount = 2; // معدل المجال + المجموع
        module.segments.forEach((seg) => {
          if (seg.type === "single") {
            moduleColumnCount += 1;
          } else if (seg.type === "submodule") {
            moduleColumnCount += 2 + seg.subjects.length; // معدل المادة + المجموع + subjects
          }
        });
        col += moduleColumnCount;
      }

      // Merge classroom/level name columns (only if not already merged)
      const classroomMerged = mergedRanges.some(range =>
        (currentColumn >= range.start && currentColumn <= range.end) ||
        (currentColumn + 1 >= range.start && currentColumn + 1 <= range.end)
      );

      if (!classroomMerged) {
        try {
          worksheet.mergeCells(2, currentColumn, 2, currentColumn + 1);
        } catch (e) {
          console.log("Merge conflict for classroom name:", e);
        }
      }

      worksheet.getRow(2).height = 15;
    }

    const row = ["الشهادة", "المعدل", "الرتبة", "مجموع المجالات"];
    modulesWithSegments.forEach((module) => {
      row.push("معدل المجال");
      row.push("المجموع");
      for (let i = module.segments.length - 1; i >= 0; i--) {
        const seg = module.segments[i];
        if (seg.type === "single") {
          row.push(seg.subject.name);
        } else if (seg.type === "submodule") {
          row.push("المجموع");
          row.push("معدل المادة");
          for (let j = 0; j < seg.subjects.length; j++) {
            row.push(seg.subjects[j].name);
          }

        }
      }

    });
    worksheet.addRow(row);

    const subjectRowIndex = hasAnySubmodules ? 3 : 2;

    worksheet.getCell(subjectRowIndex, 2).fill = PvStyles.secondHeader.moy; //المعدل
    worksheet.getCell(subjectRowIndex, 2).alignment = { textRotation: 90 };
    worksheet.getCell(subjectRowIndex, 3).fill = PvStyles.secondHeader.moduleTotal; //الرتبة
    worksheet.getCell(subjectRowIndex, 3).alignment = { textRotation: 90 };
    worksheet.getCell(subjectRowIndex, 4).fill = PvStyles.secondHeader.moduleTotal; //مجموع المجالات
    worksheet.getCell(subjectRowIndex, 4).alignment = { textRotation: 90 };
    currentColumn = 5;
    modulesWithSegments.forEach((module) => {
      worksheet.getCell(subjectRowIndex, currentColumn).fill =
        PvStyles.secondHeader.moduleMoy;
      worksheet.getCell(subjectRowIndex, currentColumn).alignment = { textRotation: 90 };
      currentColumn++;
      worksheet.getCell(subjectRowIndex, currentColumn).fill =
        PvStyles.secondHeader.moduleTotal;
      worksheet.getCell(subjectRowIndex, currentColumn).alignment = { textRotation: 90 };
      currentColumn++;

      for (let i = module.segments.length - 1; i >= 0; i--) {
        const seg = module.segments[i];
        if (seg.type === "single") {
          worksheet.getCell(subjectRowIndex, currentColumn).fill =
            PvStyles.secondHeader.subject;
          worksheet.getCell(subjectRowIndex, currentColumn).alignment = { textRotation: 90 };
          currentColumn++;
        } else if (seg.type === "submodule") {
          worksheet.getCell(subjectRowIndex, currentColumn).fill =
            PvStyles.secondHeader.moduleTotal;
          worksheet.getCell(subjectRowIndex, currentColumn).alignment = { textRotation: 90 };
          currentColumn++;
          worksheet.getCell(subjectRowIndex, currentColumn).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFCA62" },
          };
          worksheet.getCell(subjectRowIndex, currentColumn).alignment = { textRotation: 90 };
          currentColumn++;
          for (let j = 0; j < seg.subjects.length; j++) {
            worksheet.getCell(subjectRowIndex, currentColumn).fill =
              PvStyles.secondHeader.subject;
            worksheet.getCell(subjectRowIndex, currentColumn).alignment = { textRotation: 90 };
            currentColumn++;
          }
        }
      }
    });
    try {
      worksheet.mergeCells(subjectRowIndex, currentColumn, subjectRowIndex, currentColumn + 1);
    } catch (error) {
      console.log("Merge conflict for معدل المجال & المجموع:", error);
    }
    worksheet.getCell(subjectRowIndex, currentColumn).value =
      levelName || selectedClassName || "";
    worksheet.getCell(subjectRowIndex, currentColumn).fill =
      PvStyles.secondHeader.moduleTotal;

    /***************************
     * Students marks etc*******
     * *************************/
    let studentID = 0;
    let studentTemplate;
    let certifLength = 6;
    let studentLenght = 6;
    let classroomLenght = 6;
    let maxRow = [];
    let minRow = [];
    bulletinData.students.forEach((student) => {
      const studentData = [];
      if (onLevel) {
        studentData.unshift(student.fullName);
        studentData.unshift(student.classroomName);
        studentID++;
      } else {
        studentData.unshift(++studentID);
        studentData.unshift(student.fullName);
      }

      if (student.fullName.length > studentLenght)
        studentLenght = student.fullName.length;
      if (student.classroomName.length > classroomLenght)
        classroomLenght = student.classroomName.length;
      let mSum = 0;
      student.modules.forEach((m) => {
        try {
          const moduleMeta = moduleMetaById.get(m._id) || {};
          const subjectsInfo = moduleMeta.subjectsInfo || {};

          const subModuleGroups = {};
          (m.subjects || []).forEach((s) => {
            if (!s || !s._id) return;
            const sousModuleId = s.submoduleID || subjectsInfo[s._id]?.sousModule;
            if (sousModuleId) {
              if (!subModuleGroups[sousModuleId]) {
                subModuleGroups[sousModuleId] = [];
              }
              subModuleGroups[sousModuleId].push(s);
            }
          });

          const segments = [];
          const processedSubModules = new Set();

          (m.subjects || []).forEach((s) => {
            if (!s || !s._id) return;
            const sousModuleId = s.submoduleID || subjectsInfo[s._id]?.sousModule;
            if (sousModuleId) {
              if (!processedSubModules.has(sousModuleId)) {
                processedSubModules.add(sousModuleId);
                segments.push({
                  type: "submodule",
                  sousModuleId,
                  subjects: subModuleGroups[sousModuleId],
                });
              }
            } else {
              segments.push({ type: "single", subject: s });
            }
          });

          const moduleCells = [];
          const moduleMaxCells = [];
          const moduleMinCells = [];

          let moduleWeightedSum = 0;
          let moduleSubjectsSum = 0;

          for (let i = segments.length - 1; i >= 0; i--) {
            const seg = segments[i];
            if (seg.type === "single") {
              const s = seg.subject;
              const mark = isNumber(s.mark) ? Number(Number(s.mark).toFixed(2)) : "--";
              moduleCells.unshift(mark);
              if (isNumber(s.mark)) {
                moduleSubjectsSum += Number(s.mark);
              }

              if (studentID == 1) {
                moduleMaxCells.unshift(
                  isNumber(s.max) ? Number(Number(s.max).toFixed(2)) : "--"
                );
                moduleMinCells.unshift(
                  isNumber(s.min) ? Number(Number(s.min).toFixed(2)) : "--"
                );
              }
            } else if (seg.type === "submodule") {
              let subSum = 0;

              for (let j = seg.subjects.length - 1; j >= 0; j--) {
                const s = seg.subjects[j];
                const mark = isNumber(s.mark) ? Number(Number(s.mark).toFixed(2)) : "--";
                moduleCells.unshift(mark);

                if (isNumber(s.mark)) {
                  const num = Number(s.mark);
                  subSum += num;
                  moduleSubjectsSum += num;
                }

                if (studentID == 1) {
                  moduleMaxCells.unshift(
                    isNumber(s.max) ? Number(Number(s.max).toFixed(2)) : "--"
                  );
                  moduleMinCells.unshift(
                    isNumber(s.min) ? Number(Number(s.min).toFixed(2)) : "--"
                  );
                }
              }

              const subModuleData = m.submodules?.find(
                (sm) => sm._id === seg.sousModuleId
              );
              const subAvg = subModuleData?.moyenne
                ? isNumber(subModuleData.moyenne)
                  ? Number(Number(subModuleData.moyenne).toFixed(2))
                  : subModuleData.moyenne
                : "--";

              const subTotal = subSum > 0 ? Number(subSum.toFixed(2)) : "--";

              moduleCells.unshift(subAvg);
              moduleCells.unshift(subTotal);

              if (studentID == 1) {
                moduleMaxCells.unshift("--", "--");
                moduleMinCells.unshift("--", "--");
              }
            }
          }

          const moduleTotal = Number(moduleSubjectsSum.toFixed(2));
          moduleCells.unshift(moduleTotal);
          moduleCells.unshift(isNumber(m.moyenne) ? Number(m.moyenne) : "--");

          if (studentID == 1) {
            moduleMaxCells.unshift(
              isNumber(m.maxMoyenne) ? Number(m.maxMoyenne) : "--"
            );
            moduleMaxCells.unshift("");
            moduleMinCells.unshift(
              isNumber(m.minMoyenne) ? Number(m.minMoyenne) : "--"
            );
            moduleMinCells.unshift("");
          }

          studentData.unshift(...moduleCells);
          if (studentID == 1) {
            maxRow.unshift(...moduleMaxCells);
            minRow.unshift(...moduleMinCells);
          }

          if (m.moyenne != "--") moduleWeightedSum += Number(m.moyenne * m.coef);
          mSum += moduleWeightedSum;
        } catch (error) {
          console.log(student, m, error);
        }
      });
      studentData.unshift(Number(mSum.toFixed(2)));
      const rank =
        usePersonalizedAverage &&
          bulletinType === "MS" &&
          student.personalizedRank
          ? student.personalizedRank
          : student.rank;
      studentData.unshift(rank);
      const moyenne =
        usePersonalizedAverage && bulletinType === "MS"
          ? student.personalizedMoyenne
          : student.moyenne;
      studentData.unshift(isNumber(moyenne) ? Number(moyenne) : "--");
      const certif = getCertificationNameByMoyenne(moyenne, certifs);
      studentData.unshift(certif);
      if (certif.length > certifLength) certifLength = certif.length;
      if (studentID == 1) {
        const minMoy =
          usePersonalizedAverage && bulletinType === "MS"
            ? bulletinData.personalizedMoyenneMin
            : bulletinData.minMoyenne;
        const maxMoy =
          usePersonalizedAverage && bulletinType === "MS"
            ? bulletinData.personalizedMoyenneMax
            : bulletinData.maxMoyenne;
        maxRow.unshift("");
        maxRow.unshift("");
        minRow.unshift("");
        minRow.unshift("");
        maxRow.unshift(isNumber(maxMoy) ? Number(maxMoy) : "--");
        minRow.unshift(isNumber(minMoy) ? Number(minMoy) : "--");
        studentTemplate = studentData;
      }
      worksheet.addRow(studentData);
    });
    maxRow.unshift("");
    maxRow.push("اعلى عدد بالقسم");
    minRow.unshift("");
    minRow.push("ادنى عدد بالقسم");
    worksheet.addRow(maxRow);
    worksheet.addRow(minRow);

    const maxRowIndex = bulletinData.students.length + headerRowCount + 1;
    const minRowIndex = bulletinData.students.length + headerRowCount + 2;

    worksheet.mergeCells(
      maxRowIndex,
      studentTemplate.length - 1,
      maxRowIndex,
      studentTemplate.length
    );
    worksheet.mergeCells(
      minRowIndex,
      studentTemplate.length - 1,
      minRowIndex,
      studentTemplate.length
    );

    /*****************************************************
     * Bordering and text alignment marks etc**************
     * ***************************************************/
    for (let i = 1; i < worksheet.actualRowCount + 1; i++) {
      const row = worksheet.getRow(i);
      row.eachCell((cell) => {
        cell.font = { ...cell.font, name: "Arial" };
        if (i == 1) cell.font = { ...cell.font, bold: true };
        if (i > headerRowCount && i != 3) {
          if (![1, studentTemplate.length + 1].includes(cell.col)) {
            cell.fill = PvStyles.secondHeader.moduleTotal;
          }
          //if (i % 2 == 1) {
          //  cell.fill = cell.fill
          //    ? {
          //        ...cell.fill,
          //        fgColor: { argb: "DBDBDB" },
          //      }
          //    : {
          //        fgColor: { argb: "DBDBDB" },
          //      };
          //}
        }
        cell.border = PvStyles.all.border;

        if (onLevel && cell.col == studentTemplate.length + 1 && i > headerRowCount)
          cell.alignment = {
            ...cell.alignment,
            ...PvStyles.all.nameAlignment,
          };
        else if (!onLevel && cell.col == studentTemplate.length && i > headerRowCount)
          cell.alignment = {
            ...cell.alignment,
            ...PvStyles.all.nameAlignment,
          };
        else
          cell.alignment = {
            ...cell.alignment,
            ...PvStyles.all.alignment,
          };
        if (i == worksheet.actualRowCount - 1) {
          if (isNumber(cell.value))
            cell.font = { ...cell.font, color: { argb: "8BC34A" } };
          else if (cell.value.length > 5) {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "8CC24A" },
            };
          }
        }
        if (i == worksheet.actualRowCount) {
          if (isNumber(cell.value))
            cell.font = { ...cell.font, color: { argb: "F44336" } };
          else if (cell.value.length > 5) {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFADA8" },
            };
          }
        }
      });
    }

    worksheet.getColumn(1).width = certifLength + 2;
    if (onLevel) {
      worksheet.getColumn(studentTemplate.length - 1).width =
        classroomLenght + 4;
      worksheet.getColumn(studentTemplate.length).width = studentLenght + 4;
    } else {
      worksheet.getColumn(studentTemplate.length - 1).width = studentLenght + 4;
    }
  }
  if (workbook.worksheets.length === 0) return;
  // exporting process
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/octet-stream" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `PV ${btTypeName}${onLevel ? "" : " - " + selectedClassName
    }.xlsx`;
  link.click();
};
const printPVBulletinLevel = async (config) => {
  const {
    selectedLevel,
    schoolDetails,
    selectedStudent,
    selectedStudentName,
    settings,
    type,
    selectedTrimester,
    bulletinType,
    certifs,
    selectedClasse,
    selectedClassName,
    sortBy,
    sortOrder,
    usePersonalizedAverage,
    schoolarYearName,
  } = config;

  const doc = new JsPDF({
    orientation: "l",
    unit: "mm",
    format: "a3",
  });
  let bulletinData;

  await apiClient
    .get(
      "/bulletin/v2/pv/level/" +
      bulletinType +
      "/" +
      selectedLevel +
      "/" +
      selectedTrimester
    )
    .then(({ data }) => {
      bulletinData = applyPvSorting(data, sortBy, sortOrder);
    });

  const cellToDelete = {};
  const head = [];
  const modulesHead = [];

  const defaultMax = [cellToDelete];
  const defaultMin = [cellToDelete];
  defaultMax.unshift(
    { content: "اعلى عدد بالمستوى", colSpan: 2 },
    cellToDelete
  );
  defaultMin.unshift(
    { content: "ادنى عدد بالمستوى", colSpan: 2 },
    cellToDelete
  );
  let listModules = await getModules(
    selectedLevel,
    bulletinType,
    selectedTrimester
  );

  const moduleMetaById = new Map();
  listModules.forEach((m) => {
    if (m && m._id) {
      moduleMetaById.set(m._id, m);
    }
  });

  const subModulesRow = [cellToDelete];
  let hasAnySubmodules = false;

  for (const m of listModules) {
    if (!m || !m.subjects || !Array.isArray(m.subjects)) continue;

    const subjectsInfo = m.subjectsInfo || {};
    const subModuleIds = new Set();
    (m.subjects || []).forEach((s) => {
      if (!s || !s._id) return;
      const sousModuleId = subjectsInfo[s._id]?.sousModule;
      if (sousModuleId) {
        subModuleIds.add(sousModuleId);
      }
    });

    const subModulesData = {};
    const subModulePromises = Array.from(subModuleIds).map(async (sousModuleId) => {
      const subModuleData = await getSubModule(sousModuleId);
      subModulesData[sousModuleId] = subModuleData?.name || "";
    });
    await Promise.all(subModulePromises);

    // Now build segments: group subjects by sub-module while maintaining order
    // First, group all subjects by their sub-module ID
    const subModuleGroups = {};

    (m.subjects || []).forEach((s) => {
      if (!s || !s._id) return;
      const sousModuleId = subjectsInfo[s._id]?.sousModule;
      if (sousModuleId) {
        if (!subModuleGroups[sousModuleId]) {
          subModuleGroups[sousModuleId] = [];
        }
        subModuleGroups[sousModuleId].push(s);
      }
    });

    const segments = [];
    const processedSubModules = new Set();

    (m.subjects || []).forEach((s) => {
      if (!s || !s._id) return;
      const sousModuleId = subjectsInfo[s._id]?.sousModule;
      if (sousModuleId) {
        if (!processedSubModules.has(sousModuleId)) {
          processedSubModules.add(sousModuleId);
          segments.push({
            type: "submodule",
            sousModuleId,
            subjects: subModuleGroups[sousModuleId],
            name: subModulesData[sousModuleId],
          });
        }

      } else {
        segments.push({ type: "single", subject: s });
      }
    });

    const moduleHasSubmodules = segments.some(seg => seg.type === "submodule");
    if (moduleHasSubmodules) hasAnySubmodules = true;

    if (moduleHasSubmodules) {
      for (let i = segments.length - 1; i >= 0; i--) {
        const seg = segments[i];

        if (seg.type === "single") {
          subModulesRow.unshift("");
        } else if (seg.type === "submodule") {
          const colSpan = seg.subjects.length + 2;
          subModulesRow.unshift({
            content: seg.name || "",
            colSpan: colSpan,
          });
          for (let j = 1; j < colSpan; j++) {
            subModulesRow.unshift(cellToDelete);
          }
        }
      }

      subModulesRow.unshift({ content: "", colSpan: 2 });
    } else {
      subModulesRow.unshift({
        content: "",
        colSpan: m.subjects.length + 2,
      });

      for (let i = 0; i < m.subjects.length + 1; i++) {
        subModulesRow.unshift(cellToDelete);
      }
    }
  }

  const emptySubModuleRow = [cellToDelete];
  listModules.forEach((m) => {
    const subjectsInfo = m.subjectsInfo || {};

    const subModuleGroups = {};
    (m.subjects || []).forEach((s) => {
      if (!s || !s._id) return;
      const sousModuleId = subjectsInfo[s._id]?.sousModule;
      if (sousModuleId) {
        if (!subModuleGroups[sousModuleId]) {
          subModuleGroups[sousModuleId] = [];
        }
        subModuleGroups[sousModuleId].push(s);
      }
    });

    const segments = [];
    const processedSubModules = new Set();

    (m.subjects || []).forEach((s) => {
      if (!s || !s._id) return;
      const sousModuleId = subjectsInfo[s._id]?.sousModule;
      if (sousModuleId) {
        if (!processedSubModules.has(sousModuleId)) {
          processedSubModules.add(sousModuleId);
          segments.push({
            type: "submodule",
            sousModuleId,
            subjects: subModuleGroups[sousModuleId], // All subjects for this sub-module
          });
        }
      } else {
        segments.push({ type: "single", subject: s });
      }
    });

    let moduleColumnCount = 0;

    for (let i = segments.length - 1; i >= 0; i--) {
      const seg = segments[i];
      if (seg.type === "single") {
        head.unshift(seg.subject.name);
        defaultMax.unshift({ content: "--" });
        defaultMin.unshift({ content: "--" });
        emptySubModuleRow.unshift("");
        moduleColumnCount += 1;
      } else if (seg.type === "submodule") {
        // Add subject names (process subjects in reverse order too)
        for (let j = seg.subjects.length - 1; j >= 0; j--) {
          const s = seg.subjects[j];
          head.unshift(s.name);
          defaultMax.unshift({ content: "--" });
          defaultMin.unshift({ content: "--" });
          emptySubModuleRow.unshift("");
          moduleColumnCount += 1;
        }

        head.unshift("معدل المادة");
        defaultMax.unshift({ content: "--" });
        defaultMin.unshift({ content: "--" });
        emptySubModuleRow.unshift("");
        moduleColumnCount += 1;

        head.unshift("المجموع");
        defaultMax.unshift({ content: "--" });
        defaultMin.unshift({ content: "--" });
        emptySubModuleRow.unshift("");
        moduleColumnCount += 1;
      }
    }

    // Add module-level totals
    head.unshift("المجموع");
    head.unshift("معدل المجال");
    defaultMax.unshift("", "");
    defaultMin.unshift("", "");
    emptySubModuleRow.unshift("", "");
    moduleColumnCount += 2;

    modulesHead.unshift({
      content: m.name,
      colSpan: moduleColumnCount,
    });
    for (let i = 0; i < moduleColumnCount - 1; i++)
      modulesHead.unshift(cellToDelete);
  });
  head.unshift("مجموع المجالات");
  head.unshift("الرتبة");
  head.unshift("المعدل");
  head.unshift("الشهادة");
  defaultMax.unshift("", "--", "", "");
  defaultMin.unshift("", "--", "", "");
  emptySubModuleRow.unshift("", "", "", "");
  if (hasAnySubmodules) {
    subModulesRow.unshift({ content: "", colSpan: 4 });
  }

  modulesHead.unshift({ content: "النتيجة", colSpan: 4 });
  for (let i = 0; i < 3; i++) modulesHead.unshift(cellToDelete);

  const sMax = [cellToDelete];
  const sMin = [cellToDelete];
  sMax.unshift({ content: "اعلى عدد بالمستوى", colSpan: 2 }, cellToDelete);
  sMin.unshift({ content: "ادنى عدد بالمستوى", colSpan: 2 }, cellToDelete);

  const data = [];
  let studentID = 1;
  bulletinData.students.forEach((student) => {
    const studentData = [];
    studentData.unshift(student.fullName);
    studentData.unshift(student.classroomName);
    let mSum = 0;
    studentID++;
    student.modules.forEach((m) => {
      try {
        const moduleMeta = moduleMetaById.get(m._id) || {};
        const subjectsInfo = moduleMeta.subjectsInfo || {};

        // Build segments: group subjects by sub-module while maintaining order
        // First, group all subjects by their sub-module ID (use submoduleID from subject directly)
        const subModuleGroups = {};
        (m.subjects || []).forEach((s) => {
          if (!s || !s._id) return;
          // Use submoduleID directly from subject, or fallback to subjectsInfo
          const sousModuleId = s.submoduleID || subjectsInfo[s._id]?.sousModule;
          if (sousModuleId) {
            if (!subModuleGroups[sousModuleId]) {
              subModuleGroups[sousModuleId] = [];
            }
            subModuleGroups[sousModuleId].push(s);
          }
        });

        const segments = [];
        const processedSubModules = new Set();

        (m.subjects || []).forEach((s) => {
          if (!s || !s._id) return;
          const sousModuleId = s.submoduleID || subjectsInfo[s._id]?.sousModule;
          if (sousModuleId) {
            // Only create segment for this sub-module once (when we encounter its first subject)
            if (!processedSubModules.has(sousModuleId)) {
              processedSubModules.add(sousModuleId);
              segments.push({
                type: "submodule",
                sousModuleId,
                subjects: subModuleGroups[sousModuleId], // All subjects for this sub-module
              });
            }
            // Skip adding this subject again since it's already in the segment
          } else {
            segments.push({ type: "single", subject: s });
          }
        });

        const moduleCells = [];
        const moduleMaxCells = [];
        const moduleMinCells = [];

        let moduleWeightedSum = 0; // for mSum
        let moduleSubjectsSum = 0; // raw sum of all subject marks (existing "المجموع" column)

        for (let i = segments.length - 1; i >= 0; i--) {
          const seg = segments[i];
          if (seg.type === "single") {
            const s = seg.subject;
            const mark = isNumber(s.mark) ? Number(s.mark).toFixed(2) : "--";
            moduleCells.unshift(mark);
            if (isNumber(s.mark)) {
              moduleSubjectsSum += Number(s.mark);
            }

            if (studentID == 2) {
              moduleMaxCells.unshift({
                content: isNumber(s.max) ? Number(s.max).toFixed(2) : "--",
              });
              moduleMinCells.unshift({
                content: isNumber(s.min) ? Number(s.min).toFixed(2) : "--",
              });
            }
          } else if (seg.type === "submodule") {
            let subSum = 0;

            // Process subjects in reverse order to match head building
            for (let j = seg.subjects.length - 1; j >= 0; j--) {
              const s = seg.subjects[j];
              const mark = isNumber(s.mark) ? Number(s.mark).toFixed(2) : "--";
              moduleCells.unshift(mark);

              if (isNumber(s.mark)) {
                const num = Number(s.mark);
                subSum += num;
                moduleSubjectsSum += num;
              }

              if (studentID == 2) {
                moduleMaxCells.unshift({
                  content: isNumber(s.max) ? Number(s.max).toFixed(2) : "--",
                });
                moduleMinCells.unshift({
                  content: isNumber(s.min) ? Number(s.min).toFixed(2) : "--",
                });
              }
            }

            const subModuleData = m.submodules?.find(
              (sm) => sm._id === seg.sousModuleId
            );
            const subAvg = subModuleData?.moyenne
              ? (isNumber(subModuleData.moyenne)
                ? Number(subModuleData.moyenne).toFixed(2)
                : subModuleData.moyenne)
              : "--";


            const subTotal = subSum > 0 ? subSum.toFixed(2) : "--";
            moduleCells.unshift(subAvg);
            moduleCells.unshift(subTotal);

            if (studentID == 2) {
              moduleMaxCells.unshift({ content: "--" }); // المعدل
              moduleMaxCells.unshift({ content: "--" }); // المجموع
              moduleMinCells.unshift({ content: "--" }); // المعدل
              moduleMinCells.unshift({ content: "--" }); // المجموع
            }
          }
        }

        const moduleTotal = moduleSubjectsSum.toFixed(2);
        moduleCells.unshift(moduleTotal);    // المجموع
        moduleCells.unshift(m.moyenne);      // معدل المجال

        if (studentID == 2) {

          moduleMaxCells.unshift(m.maxMoyenne || "--");
          moduleMaxCells.unshift("");
          moduleMinCells.unshift(m.minMoyenne || "--");
          moduleMinCells.unshift("");
        }

        studentData.unshift(...moduleCells);
        if (studentID == 2) {
          sMax.unshift(...moduleMaxCells);
          sMin.unshift(...moduleMinCells);
        }

        // 4) Keep weighted moyenne logic as before
        if (m.moyenne != "--") moduleWeightedSum += Number(m.moyenne * m.coef);
        mSum += moduleWeightedSum;
      } catch (error) {
        console.log(student, m, error);
      }
    });
    studentData.unshift(mSum.toFixed(2));
    const rank =
      usePersonalizedAverage &&
        bulletinType === "MS" &&
        student.personalizedRank
        ? student.personalizedRank
        : student.rank;
    studentData.unshift(rank);

    const moyenne =
      usePersonalizedAverage && bulletinType === "MS"
        ? student.personalizedMoyenne
        : student.moyenne;
    studentData.unshift(moyenne);
    studentData.unshift(getCertificationNameByMoyenne(moyenne, certifs));

    data.push(studentData);
  });

  const max =
    usePersonalizedAverage &&
      bulletinType === "MS" &&
      bulletinData.personalizedMoyenneMax
      ? bulletinData.personalizedMoyenneMax
      : bulletinData.maxMoyenne;

  const min =
    usePersonalizedAverage &&
      bulletinType === "MS" &&
      bulletinData.personalizedMoyenneMin
      ? bulletinData.personalizedMoyenneMin
      : bulletinData.minMoyenne;

  sMax.unshift("", max, "", "");
  sMin.unshift("", min, "", "");

  if (bulletinData.students.length === 0) {
    data.push(defaultMax);
    data.push(defaultMin);
  } else {
    data.push(sMax);
    data.push(sMin);
  }
  const array = [
    [...modulesHead, { content: "", colSpan: 2 }, cellToDelete],
    ...(hasAnySubmodules ? [[...subModulesRow, { content: "", colSpan: 2 }, cellToDelete]] : []),
    [
      { content: "الشهادة" },
      ...Array(head.length - 1).fill(""),
      { content: selectedLevel + " المستوى", colSpan: 2 },
      cellToDelete,
    ],
    ...data,
  ];

  // fix table
  for (let row = 0; row < array.length; row++) {
    array[row] = array[row].filter((cell) => cell !== cellToDelete);
  }

  const className = selectedClassName;
  doc.setFont("Amiri", "Bold");
  doc.setFontSize(14);

  const trimesterName = getTrimesterNameArabic(selectedTrimester);
  const levelName = getLevelNameArabic(selectedLevel);
  const schoolYear = formatSchoolYear(schoolarYearName);
  const LTR = "\u2066";
  const RTL = "\u2067";
  const PDI = "\u2069";

  const t1 = `${RTL}نتائج ${trimesterName}${PDI}`;
  const t2 = `${RTL}${levelName}${PDI}`;
  const t3 = `${RTL}جميع الأقسام${PDI}`;
  const t4 = `${LTR}${schoolYear}${PDI}`;

  const headerText = `${t4} | ${t3} | ${t2} | ${t1}`;

  const pdfWidth = doc.internal.pageSize.getWidth();
  const headerX = pdfWidth / 2;
  const headerY = 8;
  doc.text(headerText, headerX, headerY, { align: "center" });

  const tableMargin = 6;
  const tableWidth = pdfWidth - 2 * tableMargin;

  doc.autoTable({
    startY: 15,
    margin: { left: tableMargin, right: tableMargin },
    tableWidth: tableWidth,
    body: array,
    theme: "striped",
    styles: {},
    bodyStyles: {
      lineWidth: 0.2,
      lineColor: [73, 138, 159],
      halign: "center",
      valign: "middle",
      fontSize: 8,
      cellPadding: 1.2,
      textColor: [0, 0, 0],
      minCellHeight: 8,
    },
    rowPageBreak: "avoid",
    columnStyles: {
      0: {
        columnWidth: 20,
      },
    },

    didDrawCell: function (data) {
      const length = data.row.raw.length;
      const subjectRowIndex = hasAnySubmodules ? 2 : 1;
      if (
        data.row.index === subjectRowIndex &&
        data.column.index < length - 1 &&
        data.column.index !== 0
      ) {
        const textWidth = doc.getTextWidth(head[data.column.index]);
        const x = data.cell.x + data.cell.width / 2;
        const cellCenterY = data.cell.y + data.cell.height / 2;
        const y = cellCenterY + textWidth / 2;
        doc.text(head[data.column.index], x, y, { angle: 90 });
      }
    },

    didParseCell: function (data) {
      const length = data.row.raw.length;
      const subjectRowIndex = hasAnySubmodules ? 2 : 1;

      data.cell.styles.textColor = [0, 0, 0];
      data.cell.styles.halign = "center";
      data.cell.styles.valign = "middle";

      if (data.column.index === length - 1) data.cell.styles.fontSize = 11;

      if (data.row.index == subjectRowIndex) {
        doc.setFont("Amiri", "normal");
        doc.setFontSize(12);
        let maxHeaderWidth = 0;
        for (let i = 0; i < head.length; i++) {
          const w = doc.getTextWidth(head[i] || "");
          if (w > maxHeaderWidth) maxHeaderWidth = w;
        }
        const cellStr = Array.isArray(data.cell.text) ? data.cell.text.join(" ") : String(data.cell.text ?? "");
        if (cellStr) {
          const wCell = doc.getTextWidth(cellStr);
          if (wCell > maxHeaderWidth) maxHeaderWidth = wCell;
        }
        data.cell.styles.minCellHeight = Math.max(36, maxHeaderWidth + 14);
        data.cell.styles.minCellWidth = 5;
        data.cell.styles.halign = "center";
        data.cell.styles.valign = "center";

        if (data.column.index !== length - 1) data.cell.styles.fontSize = 12;
        else data.cell.styles.fontSize = 12;

        if (
          [
            "معدل المجال",
            "المعدل",
            "المجموع",
            "مجموع المجالات",
            "الرتبة",
          ].includes(head[data.column.index])
        ) {
          data.cell.styles.fontStyle = "Bold";
          data.cell.styles.fontSize = 9.5;
        } else data.cell.styles.fontStyle = "normal";

        if ("معدل المجال" == head[data.column.index])
          data.cell.styles.fillColor = "#8bc34a";
        if ("معدل المادة" == head[data.column.index])
          data.cell.styles.fillColor = "#ffca62";
        else if ("المعدل" == head[data.column.index])
          data.cell.styles.fillColor = "#ffca62";
      } else {
        if (data.column.index == length - 1) data.cell.styles.fontSize = 8;
        if (
          data.column.index === length - 1 &&
          data.row.index > subjectRowIndex &&
          data.row.index < array.length - 2
        ) {
          data.cell.styles.fontSize = 10.5;
          data.cell.styles.fontStyle = "Bold";
        }
      }

      if (data.row.index == 0) {
        data.cell.styles.fontSize = 11;
        data.cell.styles.fillColor = "#ace36d";
      }
      if (data.row.index == 1 && hasAnySubmodules) {

        data.cell.styles.minCellHeight = 3;
        data.cell.styles.fontSize = 10;
      }
      //classname always Amiri
      if (data.row.index == subjectRowIndex && data.column.index == length - 1)
        data.cell.styles.font = "Amiri";
      else if (/[a-zA-Z]/.test(data.cell.text[0]))
        data.cell.styles.font = "helvetica";
      else if (
        data.row.index !== subjectRowIndex &&
        (!isNaN(Number(data.cell.text[0])) || data.cell.text[0] == "--")
      ) {
        data.cell.styles.font = "helvetica";
        data.cell.styles.fontStyle = "Bold";
      } else data.cell.styles.font = "Amiri";
      if (
        data.column.index === length - 2 &&
        data.row.index > subjectRowIndex &&
        data.row.index < array.length - 2
      ) {
        data.cell.styles.font = "Amiri";
        data.cell.styles.fontSize = 9;
      }

      if (data.row.index == array.length - 2) {
        const cellStr = Array.isArray(data.cell.text) ? data.cell.text.join(" ") : String(data.cell.text ?? "");
        if (cellStr === "اعلى عدد بالمستوى") data.cell.styles.fontSize = 10.5;
        if (data.column.index !== length - 1)
          data.cell.styles.textColor = "#8bc34a";
        else data.cell.styles.fillColor = "#8bc34a";
        if (data.cell.styles.font == "Amiri")
          data.cell.styles.fontStyle = "Bold";
      }

      if (data.row.index == array.length - 1) {
        const cellStr = Array.isArray(data.cell.text) ? data.cell.text.join(" ") : String(data.cell.text ?? "");
        if (cellStr === "ادنى عدد بالمستوى") data.cell.styles.fontSize = 10.5;
        if (data.column.index !== length - 1)
          data.cell.styles.textColor = "#f44336";
        else data.cell.styles.fillColor = "#ffaea8";
        if (data.cell.styles.font == "Amiri")
          data.cell.styles.fontStyle = "Bold";
      }
    },
  });

  let typeLabel = "";
  if (config.bulletinType === "MP") typeLabel = "Pédagogique";
  if (config.bulletinType === "MT") typeLabel = "Pilote";
  if (config.bulletinType === "MS") typeLabel = "Spécifique";

  doc.save(`PV ${typeLabel} Niveau ${selectedLevel}.pdf`);
};

function switchToPersonilized(data) {
  return {
    ...data,
    finalMoyenne: data.finalPersonalizedMoyenne,
    rankFinalMoyenne: data.rankFinalPersonalizedMoyenne,
    minFinalMoyenne: data.minFinalPersonalizedMoyenne,
    maxFinalMoyenne: data.maxFinalPersonalizedMoyenne,
    moyenneOne: data.personalizedMoyenneOne,
    moyenneTwo: data.personalizedMoyenneTwo,
    moyenneThree: data.personalizedMoyenneThree,
  };
}
async function printPVAnnuel(data, config) {
  const className = data[0]?.classroomName;
  const cellToDelete = {};

  const doc = new JsPDF({
    orientation: "m",
    unit: "mm",
    format: "a3",
  });

  doc.setFont("Amiri");

  const pdf_width = doc.internal.pageSize.getWidth();
  try {
    let arrayOfImages = config.settings.image;
    for (var i = 0; i < arrayOfImages.length; i++) {
      if (config.settings.activeBuilding === arrayOfImages[i].db) {
        var imgData = new Image();
        imgData.src = arrayOfImages[i].logo;
      }
    }

    doc.addImage(imgData, "JPEG", 10, 8, 20, 20);
  } catch (error) {
    console.log("No school logo found");
  }

  let title = "PV Annuel";
  if (config.type === "MP") {
    title = "PV Annuel Pédagogique";
  } else if (config.type === "MT") {
    title = "PV Annuel Pilote";
  } else if (config.type === "MS") {
    title = "PV Annuel Spécifique";
  }
  doc.text(title + " " + className, pdf_width / 2, 20, {
    align: "center",
  });

  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  doc.setFontSize(9);

  doc.text(new Date().toLocaleDateString("fr-FR", options), pdf_width - 17, 8, {
    align: "right",
  });

  let array = [
    [
      { content: "الرتبة", styles: { fontStyle: "Bold" } },
      { content: "معدل العام", styles: { fontStyle: "Bold" } },
      { content: "معدل الثلاثي الثالث", styles: { fontStyle: "Bold" } },
      { content: "معدل الثلاثي الثاني", styles: { fontStyle: "Bold" } },
      { content: "معدل الثلاثي الأول", styles: { fontStyle: "Bold" } },
      { content: "الأسم", styles: { fontStyle: "Bold" } },
      { content: "#", styles: { fontStyle: "Bold" } },
    ],
  ];

  let id = 1;
  //add sorting on pv annuel
  let sortingField = "rankFinalMoyenne";
  if (config.usePersonalizedAverage)
    sortingField = "rankFinalPersonalizedMoyenne";
  data = data.sort((a, b) => {
    const rankA = a[sortingField] === "--" ? Infinity : a[sortingField];
    const rankB = b[sortingField] === "--" ? Infinity : b[sortingField];

    return rankA - rankB;
  });
  data.forEach((student) => {
    if (config.usePersonalizedAverage) student = switchToPersonilized(student);
    const studentData = [];
    studentData.push(student.rankFinalMoyenne);
    studentData.push(student.finalMoyenne);
    studentData.push(student.moyenneThree);
    studentData.push(student.moyenneTwo);
    studentData.push(student.moyenneOne);
    studentData.push(student.fullName);
    studentData.push(id++);
    array.push(studentData);
  });

  // fix table
  for (let row = 0; row < array.length; row++) {
    array[row] = array[row].filter((cell) => cell !== cellToDelete);
  }

  doc.autoTable({
    startY: 35,
    body: array,
    theme: "striped",
    styles: {},
    bodyStyles: {
      lineWidth: 0.2,
      lineColor: [73, 138, 159],
      halign: "center",
      fontSize: 10,
      font: "Amiri",
      // cellPadding: 1.2,
    },
    rowPageBreak: "avoid",
  });

  //page numbering
  const pages = doc.internal.getNumberOfPages();
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  doc.setFontSize(9); //Optional

  doc.setTextColor(0, 0, 0);

  for (let j = 1; j < pages + 1; j++) {
    let horizontalPos = pageWidth / 2;
    let verticalPos = pageHeight - 10;
    doc.setPage(j);
    doc.text(`Page ${j} / ${pages}`, horizontalPos, verticalPos, {
      align: "center",
    });
  }

  //end page numbering

  doc.save(`${title} ${className}.pdf`);
}

async function printPVAnnuelByLevel(data, config) {
  const cellToDelete = {};

  const doc = new JsPDF({
    orientation: "m",
    unit: "mm",
    format: "a3",
  });

  doc.setFont("Amiri");

  const pdf_width = doc.internal.pageSize.getWidth();
  try {
    let arrayOfImages = config.settings.image;
    for (var i = 0; i < arrayOfImages.length; i++) {
      if (config.settings.activeBuilding === arrayOfImages[i].db) {
        var imgData = new Image();
        imgData.src = arrayOfImages[i].logo;
      }
    }

    doc.addImage(imgData, "JPEG", 10, 8, 20, 20);
  } catch (error) {
    console.log("No school logo found");
  }

  const levels = {
    "-2": "Préscolaire",
    "-1": "تحضيري",
    1: "سنة أولى",
    2: "سنة ثانية",
    3: "سنة ثالثة",
    4: "سنة رابعة",
    5: "سنة خامسة",
    6: "سنة سادسة",
    7: "سنة سابعة",
    8: "سنة ثامنة",
    9: "سنة تاسعة",
    10: "أولى ثانوي",
    11: "ثانية ثانوي",
    12: "ثالثة ثانوي",
    13: "رابعة ثاتوي",
  };

  let title = "PV Annuel";
  if (config.type === "MP") {
    title = "PV Annuel Pédagogique";
  } else if (config.type === "MT") {
    title = "PV Annuel Pilote";
  } else if (config.type === "MS") {
    title = "PV Annuel Spécifique";
  }

  doc.text(title + " - " + levels[config.level], pdf_width / 2, 20, {
    align: "center",
  });

  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  doc.setFontSize(9);
  doc.text(new Date().toLocaleDateString("fr-FR", options), pdf_width - 17, 8, {
    align: "right",
  });
  let array = [
    [
      { content: "الرتبة", styles: { fontStyle: "Bold" } },
      { content: "معدل العام", styles: { fontStyle: "Bold" } },
      { content: "معدل الثلاثي الثالث", styles: { fontStyle: "Bold" } },
      { content: "معدل الثلاثي الثاني", styles: { fontStyle: "Bold" } },
      { content: "معدل الثلاثي الأول", styles: { fontStyle: "Bold" } },
      { content: "القسم", styles: { fontStyle: "Bold" } },
      { content: "الأسم", styles: { fontStyle: "Bold" } },
    ],
  ];
  //add sorting on pv annuel
  let sortingField = "rankFinalMoyenne";
  if (config.usePersonalizedAverage)
    sortingField = "rankFinalPersonalizedMoyenne";
  data = data.sort((a, b) => {
    const rankA = a[sortingField] === "--" ? Infinity : a[sortingField];
    const rankB = b[sortingField] === "--" ? Infinity : b[sortingField];

    return rankA - rankB;
  });
  data.forEach((student) => {
    if (config.usePersonalizedAverage) student = switchToPersonilized(student);
    const studentData = [];
    studentData.push(student.rankFinalMoyenne);
    studentData.push(student.finalMoyenne);
    studentData.push(student.moyenneThree);
    studentData.push(student.moyenneTwo);
    studentData.push(student.moyenneOne);
    studentData.push(student.classroomName);
    studentData.push(student.fullName);
    array.push(studentData);
  });

  // fix table
  for (let row = 0; row < array.length; row++) {
    array[row] = array[row].filter((cell) => cell !== cellToDelete);
  }

  doc.autoTable({
    startY: 35,
    body: array,
    theme: "striped",
    styles: {},
    bodyStyles: {
      lineWidth: 0.2,
      lineColor: [73, 138, 159],
      halign: "center",
      fontSize: 9,
      font: "Amiri",
      // cellPadding: 1.2,
    },
    columnStyles: {
      0: { cellWidth: 20 },
    },
    rowPageBreak: "avoid",
  });

  //page numbering
  const pages = doc.internal.getNumberOfPages();
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  doc.setFontSize(9); //Optional

  doc.setTextColor(0, 0, 0);

  for (let j = 1; j < pages + 1; j++) {
    let horizontalPos = pageWidth / 2;
    let verticalPos = pageHeight - 10;
    doc.setPage(j);
    doc.text(`Page ${j} / ${pages}`, horizontalPos, verticalPos, {
      align: "center",
    });
  }

  //end page numbering

  doc.save(title + ` ${levels[config.level]}.pdf`);
}

export default {
  printPVBulletin,
  printPVBulletinLevel,
  printPVBulletinExcel,
  printPVAnnuel,
  printPVAnnuelByLevel,
};
